<form [formGroup]="configurationFormTimescedule">
  <div class="form-row row">
    <div class="form-group col-xl-4 col-lg-6">
      <label for="startDate" class="control-label required">{{'i18n.domain.import-configuration.edit.time-scedule.start-date' | translate}}</label>
      <ejs-datepicker formControlName="startDate"
                      format="dd.MM.yyyy">
      </ejs-datepicker>
      <app-error-messages [control]="configurationFormTimescedule.controls.startDate"></app-error-messages>
    </div>
    <div class="form-group col-xl-4 col-lg-6">
      <label for="ic-hasEndDate" class="control-label required">{{ 'i18n.domain.import-configuration.edit.time-scedule.end-date' | translate }}</label>
      <app-yes-no-group-button id="ic-hasEndDate" formControlName="hasEndDate"></app-yes-no-group-button>
    </div>
    <div class="form-group col-xl-4 col-lg-6">
      <label for="endDate" class="control-label" [ngClass]="{'required': configurationFormTimescedule.controls.hasEndDate.value === true}">{{'i18n.domain.import-configuration.edit.time-scedule.end-date' | translate}}</label>
      <ejs-datepicker #endDate
                      formControlName="endDate"
                      format="dd.MM.yyyy"
                      [min]="configurationFormTimescedule.controls.startDate.value">
      </ejs-datepicker>
      <app-error-messages [control]="configurationFormTimescedule.controls.endDate"></app-error-messages>
    </div>
    <div class="form-group col-xl-4 col-lg-6">
      <label for="ic-startTime" class="control-label required">{{'i18n.domain.import-configuration.edit.time-scedule.start-time' | translate}}</label>
      <ejs-timepicker id="ic-startTime"
                      formControlName="startTime"
                      enableMask="true"
                      step="15"
                      showClearButton="true"
                      floatLabelType="Never"
                      format="HH:mm">
      </ejs-timepicker>
      <app-error-messages [control]="configurationFormTimescedule.controls.startTime"></app-error-messages>
    </div>
    <div class="form-group col-xl-4 col-lg-6">
      <label for="ic-endTime" class="control-label required">{{'i18n.domain.import-configuration.edit.time-scedule.end-time' | translate}}</label>
      <ejs-timepicker id="ic-endTime"
                      formControlName="endTime"
                      enableMask="true"
                      [min]="configurationFormTimescedule.controls.startTime.value"
                      step="15"
                      showClearButton="true"
                      floatLabelType="Never"
                      format="HH:mm">
      </ejs-timepicker>
      <app-error-messages [control]="configurationFormTimescedule.controls.endTime"></app-error-messages>
    </div>
    <div class="form-group col-xl-4 col-lg-6">
      <label for="ic-repetitionIntervalInMinutes" class="control-label required">{{ 'i18n.domain.import-configuration.edit.time-scedule.repeat' | translate }}</label>
      <input id="ic-repetitionIntervalInMinutes"
             type="number" class="form-control"
             formControlName="repetitionIntervalInMinutes"
             format="n0"
             min="10"
             max="1440"/>
      <app-error-messages [control]="configurationFormTimescedule.controls.repetitionIntervalInMinutes"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-12">
      <label class="control-label required">{{ 'i18n.domain.import-configuration.edit.time-scedule.weekdays' | translate }}</label>
      <app-day-selector [form]="configurationFormTimescedule.controls.weekdays"></app-day-selector>
    </div>
  </div>
</form>
